/* Home V2: page chrome — the client-card popovers (ch 08) and the spine
   nav. Ported from REF (docs/superpowers/specs/reference/pe-rev2-draft.html):
   - client cards: "ch 08: the client cards" (3194-3222), incl. the
     outside-click/Escape close.
   - spine nav: the SPINE NAV click handler (3468-3475) plus the
     current-chapter tracking read out of REF's frame loop (the
     spine-node/is-current/is-past assignments inside frame(), ~3391-3401).
     REF builds its CHAPS array from every `section[data-ch]` in the
     document; every home-v2 section still carries data-ch="0" as an
     unwired placeholder (Task 15's concern per each section's own
     comments), so this file tracks the nine well-known #pe-* anchor ids
     instead (already in the DOM — Tasks 2/4/7-13) and caches their
     absTop directly, same "no layout reads in frame()" discipline as
     00-engine.js / 50-boards.js. */
(function () {
  'use strict';

  /* ── ch 08: the client cards ── */
  var clientsRoot = document.getElementById('pe-begin');
  if (clientsRoot) {
    (function () {
      function $(sel, r) { return (r || document).querySelector(sel); }
      function $$(sel, r) { return Array.prototype.slice.call((r || document).querySelectorAll(sel)); }

      $$('.client', clientsRoot).forEach(function (li) {
        var btn = $('.client-plus', li), card = $('.client-card', li);
        if (!btn || !card) { return; }
        card.hidden = false;

        function set(on) {
          li.classList.toggle('is-open', on);
          btn.setAttribute('aria-expanded', on ? 'true' : 'false');
        }

        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          var on = btn.getAttribute('aria-expanded') !== 'true';
          $$('.client.is-open', clientsRoot).forEach(function (o) {
            if (o !== li) {
              o.classList.remove('is-open');
              var oBtn = $('.client-plus', o);
              if (oBtn) { oBtn.setAttribute('aria-expanded', 'false'); }
            }
          });
          set(on);
        });
        li.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') { set(false); btn.focus(); }
        });
      });

      document.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('.client')) { return; }
        $$('.client.is-open', clientsRoot).forEach(function (o) {
          o.classList.remove('is-open');
          var oBtn = $('.client-plus', o);
          if (oBtn) { oBtn.setAttribute('aria-expanded', 'false'); }
        });
      });
    })();
  }

  /* ── the spine ── */
  var spineEl = document.getElementById('hv2Spine');
  if (!spineEl || !window.PEHomeV2) { return; }

  function $$(sel, r) { return Array.prototype.slice.call((r || document).querySelectorAll(sel)); }

  var nodes = $$('.hv2-spine-node', spineEl);
  if (!nodes.length) { return; }

  var utils = window.PEHomeV2.utils;
  var absTop = utils.absTop;

  /* chapters[i].t is this anchor's absolute top, refreshed in measure() —
     the only layout read this component does. */
  var chapters = nodes.map(function (n) {
    return { node: n, el: document.getElementById(n.dataset.go), t: 0 };
  }).filter(function (c) { return !!c.el; });

  var chState = -1;

  /* on-dark: the spine is fixed at the viewport's vertical centre, so it needs
     the light-on-dark treatment whenever a dark-toned section sits behind it.
     We classify every section once (by the luminance of its rendered
     background) in measure(), then in frame() toggle .on-dark from whichever
     section spans the viewport midline — no per-frame style reads. */
  // every top-level section (the turn section intentionally carries no data-ch,
  // so we can't filter on it — take all direct-child sections instead).
  var toneSections = $$('.home-v2 > section').map(function (el) {
    return { el: el, t: 0, h: 0, dark: false };
  });
  var darkState = null;

  function isDarkBg(el) {
    var m = getComputedStyle(el).backgroundColor.match(/rgba?\(([^)]+)\)/);
    if (!m) { return false; }
    var p = m[1].split(',');
    // fully transparent → inherits the light page background, treat as light
    if (p.length > 3 && parseFloat(p[3]) === 0) { return false; }
    var lum = (0.299 * +p[0] + 0.587 * +p[1] + 0.114 * +p[2]) / 255;
    return lum < 0.5;
  }

  function measure() {
    chapters.forEach(function (c) { c.t = absTop(c.el); });
    toneSections.forEach(function (s) {
      s.t = absTop(s.el);
      s.h = s.el.offsetHeight;
      s.dark = isDarkBg(s.el);
    });
  }

  /* same rule as REF's frame(): the chapter line sits 42% down the
     viewport; the current chapter is the last anchor at or above it. */
  function frame(y, vh) {
    var line = vh * 0.42, ch = 0;
    for (var i = 0; i < chapters.length; i++) {
      if (chapters[i].t - y <= line) { ch = i; }
    }

    // section behind the spine (viewport vertical centre)
    var mid = y + vh * 0.5, dark = false;
    for (var j = 0; j < toneSections.length; j++) {
      var s = toneSections[j];
      if (mid >= s.t && mid < s.t + s.h) { dark = s.dark; break; }
    }
    if (dark !== darkState) {
      darkState = dark;
      spineEl.classList.toggle('on-dark', dark);
    }

    if (ch === chState) { return; }
    chState = ch;
    chapters.forEach(function (c, idx) {
      c.node.classList.toggle('is-current', idx === ch);
      c.node.classList.toggle('is-past', idx < ch);
    });
  }

  window.PEHomeV2.register({ measure: measure, frame: frame });

  nodes.forEach(function (n) {
    n.addEventListener('click', function () {
      var el = document.getElementById(n.dataset.go);
      if (!el) { return; }
      el.scrollIntoView({ behavior: window.PEHomeV2.reduce ? 'auto' : 'smooth', block: 'start' });
    });
  });
})();

/* ── the newsletter ── */
(function () {
  var form = document.getElementById('hv2NewsForm');
  if (!form) { return; }

  var input = document.getElementById('hv2NewsEmail');
  var note = document.getElementById('hv2NewsNote');
  var baseText = note.textContent;

  function clearError() {
    input.setAttribute('aria-invalid', 'false');
    note.classList.remove('is-err');
    note.textContent = baseText;
  }

  input.addEventListener('input', clearError);

  form.addEventListener('submit', function (e) {
    var action = form.getAttribute('action');
    var email = input.value.trim();
    var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    var isValid = emailRegex.test(email);

    // If no action URL configured, block submit. This is a site-config
    // problem, not a user-input one: aria-invalid reflects only email
    // validity, and focus is not stolen to the input.
    if (!action) {
      e.preventDefault();
      input.setAttribute('aria-invalid', isValid ? 'false' : 'true');
      note.classList.add('is-err');
      note.textContent = 'Newsletter signup is not configured yet.';
      return;
    }

    // If email invalid, block submit
    if (!isValid) {
      e.preventDefault();
      input.setAttribute('aria-invalid', 'true');
      note.classList.add('is-err');
      note.textContent = 'That address does not look right. Check it and try again.';
      input.focus();
      return;
    }

    // Email is valid and action is configured; allow native form submit
  });
})();
